var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkplaceSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Workplace_Security",
    "data-name": "Workplace Security",
    transform: "translate(0.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 88,
    cy: 88,
    r: 88,
    transform: "translate(-0.056)",
    fill: "rgba(214,233,255,0.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 75.3,
    cy: 75.3,
    r: 75.3,
    transform: "translate(12.7 12.7)",
    fill: "#d1e6ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627",
    transform: "translate(27 27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10626",
    "data-name": "Group 10626"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 61,
    cy: 61,
    r: 61,
    transform: "translate(-0.056)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "laptop_mac_black_24dp",
    transform: "translate(52.944 53)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3603",
    "data-name": "Path 3603",
    d: "M0,0H70.464V70.464H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3604",
    "data-name": "Path 3604",
    d: "M4,5H50.976V37.3H4Z",
    transform: "translate(7.744 9.68)",
    fill: "#d6e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3605",
    "data-name": "Path 3605",
    d: "M58.72,47.04a5.864,5.864,0,0,0,5.843-5.872l.029-32.3A5.889,5.889,0,0,0,58.72,3H11.744A5.889,5.889,0,0,0,5.872,8.872v32.3a5.889,5.889,0,0,0,5.872,5.872H0a5.889,5.889,0,0,0,5.872,5.872h58.72a5.889,5.889,0,0,0,5.872-5.872ZM11.744,8.872H58.72v32.3H11.744Zm23.488,41.1a2.936,2.936,0,1,1,2.936-2.936A2.945,2.945,0,0,1,35.232,49.976Z",
    transform: "translate(0 5.808)",
    fill: "#12355f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkplaceSecurity);
export default __webpack_public_path__ + "static/media/Workplace Security.1f3166067fac006eb9e97cf197a37738.svg";
export { ForwardRef as ReactComponent };